<div *ngIf="supplier" class="card">
    <div *ngIf="sharedDatasSvc.debug && supplierStatutCod=='800' " class="row pt-5 small">
        <div class="col-12 d-flex mb-1">
            <button type="button" class="btn btn-sm btn-info mr-2" (click)="getRelanceDocList()">Liste des documents
                relancables</button>
                <label *ngIf="NoRelanceDoc && relanceDocListSubmitted" class="control-label mr-2">Pas de document de relance</label>
            <button type="button" class="btn btn-sm btn-success" (click)="relanceDocs()"
                [disabled]="relanceDocList.length==0">Relance documentaire</button>
        </div>
        <div *ngIf="!NoRelanceDoc" class="col-12 mb-1">            
            <table class="table table-bordered table-condensed mr-2 flex-fill">
                <thead>
                    <tr>
                        <th>
                            Identifiant
                        </th>
                        <th>
                            Document
                        </th>
                        <th>
                            Statut
                        </th>
                        <th>
                            Expire le
                        </th>
                        <th>
                            Derniere relance
                        </th>
                        <th>
                            Relance J-20
                        </th>
                        <th>
                            Relance si Echu
                        </th>
                        <th>
                            Statut suivant
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let doc of relanceDocList">
                        <td>{{doc.Id}}</td>
                        <td>{{RelanceDoc2PafDoc(doc)?.LblCod}}</td>
                        <td>{{doc.DocStatutCod}}</td>
                        <td>{{doc.DateExpi}}</td>
                        <td>{{doc.DateDerniereRelance | date:'shortDate'}}</td>
                        <td>{{doc.RelanceJ20}}</td>
                        <td>{{doc.RelanceEchu}}</td>
                        <td>{{doc.StatutCodNext}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-header">
        <label class="control-label">
            <paflabel lblCod="Documents_reglementaires"></paflabel> 
            &nbsp;<span style="text-decoration: underline;" class="text-danger" paflabel="Msg_Titre_Docs_reglementaires"></span>
        </label>
        <doc-histo-button class="float-right" [supplier]="supplier"></doc-histo-button>
    </div>
    <div class="card-body">

        <div *ngIf="isLoading" class="col-12 d-flex flex-column align-items-center my-5">
            <h5 class="my-5">
                <label *ngIf="firstLoad" class="control-label text-info text-center" paflabel="Msg_interrogation_Api_SIREN"></label>
                <label *ngIf="!firstLoad" class="control-label text-info text-center" paflabel="Chargement_en_cours"></label>
            </h5>
            <h1 class="text-info">
                <i class="fas fa-spinner fa-pulse"></i>
            </h1>
        </div>
        <div *ngIf="!isLoading">
            <div class="row mt-1 mb-2 text-center">
                <div class="col-3">
                    <label class="control-label" paflabel="Veuillez_deposer_les_documents_demandes"></label>
                </div>
                <div class="col-1">
                    <label class="control-label" paflabel="Modele_Endel"></label>                    
                </div>
                <div class="col-2">
                    <label class="control-label" paflabel="Statut"></label>                    
                </div>
                <div class="col-3">
                    <label class="control-label" paflabel="Renseigner_la_date_pour_autoriser_le_depot"></label>                    
                </div>
                <div class="col-3">
                    <label class="control-label" paflabel="Nom_du_fichier_depose"></label>                    
                </div>
            </div>
            <div *ngFor="let suppDoc of lstSupplierRegDoc">
                <supplier-doc-row  [lstPafDocuments]="pafDocuments" [lstDocTyps]="lstDocTyps" [lstDocStatuts]="lstDocStatuts" [supplier]="supplier" [supplierDoc]="suppDoc" (supplierDocChange)="supplierDocChange($event)" [readonly]="docReadonly(suppDoc)"></supplier-doc-row>
            </div>
            <pre *ngIf="sharedDatasSvc.debug">
                {{lstSupplierRegDoc | json}}
            </pre>
            <div class="row my-3">
                <div class="col">
                    <label class="control-label">
                        <paflabel lblCod="Nous_verifierons_la_validite_de_vos_documents"></paflabel>
                        <a href="mailto://suivi.fournisseurs@altradendel.com">suivi.fournisseurs@altradendel.com</a>
                    </label>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-1">
                    <label class="control-label" paflabel="Commentaires_relatifs_a_vos_documents"></label>
                </div>
                <div class="col mb-3">
                    <textarea class="form-control" name="DocComments" [(ngModel)]="supplier.DocComments" rows="3"
                        style="width: 100%;height:60px;" [disabled]="docsReglementairesDisabled() || !isEditing()"></textarea>
                </div>
            </div>
        </div>
    </div>
</div>